<template>
    <div class="Datepicker-dropdown-calendar-ranges">
        <ul v-if="ranges">
            <li
                v-for="range in listedRanges"

                tabindex="0"

                :key="range.label"
                :data-range-key="range.label"

                :class="{ active: range.selected === true }"

                @click="clickRange( range.value )"
            >
                {{range.label}}
            </li>

            <li
                v-if="showCustomRangeLabel"

                tabindex="0"

                :class="{ active: customRangeActive || !selectedRange }"

                @click="clickCustomRange"
            >
                {{localeData.customRangeLabel}}
            </li>
        </ul>
    </div>
</template>

<script>
import date     from './utils/date.js';

import props    from './utils/CalendarRanges/props.js';
import methods  from './utils/CalendarRanges/methods.js';
import computed from './utils/CalendarRanges/computed.js';

export default
{
    name   : "CalendarRanges",
    mixins : [ date, props, computed, methods ],

    data()
    {
        return (
        {
            customRangeActive: false
        })
    }
}
</script>

<style lang="scss">
body
{
    &[data-theme="light"]
    {
        .Datepicker-dropdown-calendar-ranges
        {
            --datepicker-dropdown-calendar-range-text-color: var(--light-text-color-primary);
            --datepicker-dropdown-calendar-range-border-color: transparent;
            --datepicker-dropdown-calendar-range-background-color: transparent;

            --datepicker-dropdown-calendar-range-hover-text-color: var(--light-text-color-primary);
            --datepicker-dropdown-calendar-range-hover-border-color: transparent;
            --datepicker-dropdown-calendar-range-hover-background-color: var(--light-surfaces-off-white);

            --datepicker-dropdown-calendar-range-focus-text-color: var(--light-text-color-primary);
            --datepicker-dropdown-calendar-range-focus-border-color: var(--primary-colors-blue-60);
            --datepicker-dropdown-calendar-range-focus-background-color: var(--primary-colors-blue-10);

            --datepicker-dropdown-calendar-range-selected-text-color: var(--primary-colors-blue-60);
            --datepicker-dropdown-calendar-range-selected-border-color: var(--primary-colors-blue-60);
            --datepicker-dropdown-calendar-range-selected-background-color: var(--primary-colors-blue-10);
        }
    }

    &[data-theme="dark"]
    {
        .Datepicker-dropdown-calendar-ranges
        {
            --datepicker-dropdown-calendar-range-text-color: var(--dark-text-color-primary);
            --datepicker-dropdown-calendar-range-border-color: transparent;
            --datepicker-dropdown-calendar-range-background-color: transparent;

            --datepicker-dropdown-calendar-range-hover-text-color: var(--dark-text-color-primary);
            --datepicker-dropdown-calendar-range-hover-border-color: transparent;
            --datepicker-dropdown-calendar-range-hover-background-color: var(--layout-primary-background-color);

            --datepicker-dropdown-calendar-range-focus-text-color: var(--dark-text-color-primary);
            --datepicker-dropdown-calendar-range-focus-border-color: var(--primary-colors-blue-40);
            --datepicker-dropdown-calendar-range-focus-background-color: var(--dark-surfaces-gunmetal);

            --datepicker-dropdown-calendar-range-selected-text-color: var(--primary-colors-blue-40);
            --datepicker-dropdown-calendar-range-selected-border-color: var(--primary-colors-blue-40);
            --datepicker-dropdown-calendar-range-selected-background-color: var(--dark-surfaces-gunmetal);
        }
    }
}

.Datepicker-dropdown-calendar-ranges
{
    min-width: px(150);

    padding: px(16) px(8);

    border-right: 1px solid var(--layout-border-color);

    ul
    {
        @include font-body-sm-regular;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        gap: px(8);

        li
        {
            display: flex;

            width: 100%;

            padding: px(8) px(12);

            color: var(--datepicker-dropdown-calendar-range-text-color);
            border: 1px solid var(--datepicker-dropdown-calendar-range-border-color);
            background-color: var(--datepicker-dropdown-calendar-range-background-color);

            border-radius: 4px;

            cursor: pointer;

            transition: all 250ms ease-in-out;

            &:hover
            {
                color: var(--datepicker-dropdown-calendar-range-hover-text-color);
                border: 1px solid var(--datepicker-dropdown-calendar-range-hover-border-color);
                background-color: var(--datepicker-dropdown-calendar-range-hover-background-color);
            }

            &:focus
            {
                color: var(--datepicker-dropdown-calendar-range-focus-text-color);
                border: 1px dashed var(--datepicker-dropdown-calendar-range-focus-border-color);
                background-color: var(--datepicker-dropdown-calendar-range-focus-background-color);
            }

            &.active
            {
                color: var(--datepicker-dropdown-calendar-range-selected-text-color);
                border: 1px solid var(--datepicker-dropdown-calendar-range-selected-border-color);
                background-color: var(--datepicker-dropdown-calendar-range-selected-background-color);
            }
        }
    }
}
</style>